import { BILLCHECK_FLOW_STEPS } from '../components/MultiStepCreationModal/MultiStepCreationModal';
import type { BillcheckDetails } from '@/@types/billCheckV3';
import {
  ACCOUNTING_PERIOD_DETAILS,
  BALANCE_DETAILS,
  CUSTOMER_DETAILS,
  ERROR,
  OPERATIONAL_STATEMENT_UPLOAD,
} from '@/domain/routes';

export const isBillCheckV3FlowStep = (currentStep: string | null) => {
  return !!currentStep && [...BILLCHECK_FLOW_STEPS, ERROR].includes(currentStep);
};

/**
 * Determines the current step in the bill check process based on the details provided.
 *
 * @param {BillcheckDetails} billCheckDetails - The object containing bill check details.
 * @returns {string} - The current step in the bill check process.
 */
export const getBillCheckDropOffStep = (billCheckDetails: BillcheckDetails) => {
  if (
    !billCheckDetails?.firstName ||
    !billCheckDetails?.lastName ||
    !billCheckDetails?.email ||
    !billCheckDetails?.gender
  )
    return CUSTOMER_DETAILS;
  if (!billCheckDetails?.balanceAmount || !billCheckDetails?.balanceType) return BALANCE_DETAILS;
  if (
    !billCheckDetails?.accountingPeriodFrom ||
    !billCheckDetails?.accountingPeriodTo ||
    !billCheckDetails.deliveryDate
  )
    return ACCOUNTING_PERIOD_DETAILS;
  return OPERATIONAL_STATEMENT_UPLOAD;
};
